<template>
    <div class="inventory container-fluid">
        <div class="row">
            <Menu title="Inventory" />
            <Inventory id="inventory_view"></Inventory>
        </div>
    </div>
</template>


<script>
    import Menu from '@/components/menu_component.vue';
    import Inventory from '@/components/Inventory_component.vue';

    export default {
        name: 'inventory',
        data() {
            return {
                'check': 'hello'
            }
        },
        components: {
            Menu,
            Inventory
        }
    }
</script>